var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMjmActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qo0o9rnmva",
    x1: 0.5,
    y1: 0.425,
    x2: 0.5,
    y2: 1.624,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m4a51x4wrb",
    x1: 0.5,
    y1: -0.765,
    x2: 0.5,
    y2: 0.169,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f1177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "myazc44zoc",
    y1: 0,
    y2: 1,
    xlinkHref: "#qo0o9rnmva"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zap3d970qd",
    y1: 1,
    y2: 0,
    xlinkHref: "#qo0o9rnmva"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41",
    d: "M46.129 56.867a11.419 11.419 0 0 0 5.3-1.294c-.463-5.261-2.29-9.2-5.3-9.246-3.059-.053-4.833 3.985-5.3 9.245a11.42 11.42 0 0 0 5.3 1.295",
    transform: "translate(-25.909 -25.571)",
    style: {
      fill: "url(#qo0o9rnmva)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56",
    d: "M46.129 56.867a11.419 11.419 0 0 0 5.3-1.294c-.463-5.261-2.29-9.2-5.3-9.246-3.059-.053-4.833 3.985-5.3 9.245a11.42 11.42 0 0 0 5.3 1.295",
    transform: "translate(-25.909 -25.571)",
    style: {
      fill: "url(#m4a51x4wrb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "M59.831 14.739a3.18 3.18 0 1 1-3.18-3.18 3.18 3.18 0 0 1 3.18 3.18",
    transform: "translate(-36.43 3.376)",
    style: {
      fill: "#0379a0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 13",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "translate(19.451 4.725)",
    style: {
      fill: "url(#myazc44zoc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 14",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "rotate(-30 18.708 -17.323)",
    style: {
      fill: "url(#myazc44zoc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 16",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "rotate(-60 13.327 1.403)",
    style: {
      fill: "url(#myazc44zoc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 17",
    d: "M0 3.165V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "rotate(-120 19.94 -2.017)",
    style: {
      fill: "url(#zap3d970qd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 15",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.328a.836.836 0 1 1-1.672 0z",
    transform: "rotate(-150 15.11 1.577)",
    style: {
      fill: "url(#zap3d970qd)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjmActivity);
export default __webpack_public_path__ + "static/media/MJM-Activity.9ad3c3b3d3b48acc0caf4bf4d85cc3cd.svg";
export { ForwardRef as ReactComponent };